import React from "react";
import "./Portfolio.css";
import Navbar from "../Components/Navbar";
import PortfolioCard from "../Components/PortfolioCard";
import Contact from "../Components/Contact";
import Footer from "../Components/Footer";
import PortfolioData from "../Data/PortfolioData";

const Portfolio = () => {
  document.title = "Portfolio - Rizatzmi";

  React.useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <section className="Portfolio">
        <h1 className="Portfolio-Title">PORTFOLIO</h1>
        <div className="Portfolio-Wrapper">
          {PortfolioData.map((item) => {
            return (
              <div key={item.id}>
                <PortfolioCard
                  title={item.title}
                  image={item.img}
                  description={item.description}
                  link={item.link}
                />
              </div>
            );
          })}
        </div>
        <div className="Contact-Section">
          <Contact />
        </div>
      </section>
      <div className="Footer-Section">
        <Footer />
      </div>
    </>
  );
};

export default Portfolio;
